var _circle, _path, _path2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgDemanddone = function SvgDemanddone(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#44E47A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 9.5C12.1402 9.5 9 12.6402 9 16.5C9 20.3598 12.1402 23.5 16 23.5C19.8598 23.5 23 20.3598 23 16.5C23 12.6402 19.8598 9.5 16 9.5ZM16 22.1C12.9123 22.1 10.4 19.5877 10.4 16.5C10.4 13.4123 12.9123 10.9 16 10.9C19.0877 10.9 21.6 13.4123 21.6 16.5C21.6 19.5877 19.0877 22.1 16 22.1Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5993 17.6109L12.99 16.0044L12.0016 16.9956L14.6007 19.5891L19.2949 14.8949L18.3051 13.9051L14.5993 17.6109Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDemanddone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/demanddone.03defe42.svg";
export { ForwardRef as ReactComponent };